export default "__VITE_ASSET__DUSvY43Q__"